/* היצירון · Shopify theme — light interactions (no framework) */
(function () {
  // Mobile nav toggle
  document.addEventListener("click", function (e) {
    var t = e.target.closest("[data-menu-toggle]");
    if (t) {
      var nav = document.getElementById("nav-links");
      if (nav) nav.classList.toggle("open");
    }
  });

  // Quantity steppers (product + cart): buttons with data-qty="+/-" next to an input
  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-qty]");
    if (!b) return;
    var wrap = b.closest("[data-qty-wrap]");
    var input = wrap && wrap.querySelector('input[type="number"]');
    if (!input) return;
    var val = parseInt(input.value || "1", 10);
    val += b.getAttribute("data-qty") === "+" ? 1 : -1;
    if (val < (parseInt(input.min, 10) || 1)) val = parseInt(input.min, 10) || 1;
    input.value = val;
    // On the cart page, changing qty submits the line form
    if (input.hasAttribute("data-cart-qty")) input.form && input.form.submit();
  });

  // Product gallery thumbnails
  document.addEventListener("click", function (e) {
    var th = e.target.closest("[data-thumb]");
    if (!th) return;
    var main = document.querySelector("[data-main-image]");
    if (main) main.src = th.getAttribute("data-thumb");
    document.querySelectorAll("[data-thumb]").forEach(function (x) { x.classList.remove("active"); });
    th.classList.add("active");
  });
})();
